import React from 'react';
import '../pages/OurArbitrators.css';
import { Container, Row, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGavel } from '@fortawesome/free-solid-svg-icons';

const ARBITRATORS = [
  {
    name: 'Gulabrao Wamanrao Awasarmol',
    qualification: 'LL.M.',
    designation: 'Retd. District Judge',
  },
  {
    name: 'Eknath Shivram Budhawat',
    qualification: 'LL.B.',
    designation: 'Retd. Solicitor cum Dy. Secretary, Law & Judiciary Department, Mantralaya, Mumbai',
  },
  {
    name: 'Bhaskar H. More',
    qualification: 'LL.B.',
    designation: 'Ex. Appellate and Retd. Law Officer, BMC',
  },
  {
    name: 'Suresh Shivaji Kasture',
    qualification: 'LL.B.',
    designation: 'Retd. Additional Public Prosecutor and Advocate',
  },
];

function OurArbitrators() {
  return (
    <Container fluid className="arbitratorsContainer">
      <Row className="justify-content-center">
        <Col md={10} className="text-center">
          <h2 className="arbitratorsHeading">Our Arbitrators</h2>
          <p className="arbitratorsSubheading">
            A distinguished panel of retired judges and legal experts entrusted with fair, impartial and
            timely resolution of disputes.
          </p>
        </Col>
      </Row>

      <Row className="arbitratorsCards g-4">
        {ARBITRATORS.map(({ name, qualification, designation }) => (
          <Col xs={12} sm={6} lg={3} key={name}>
            <div className="arbitratorCard">
              <div className="arbitratorIconBox">
                <FontAwesomeIcon icon={faGavel} />
              </div>
              <h5 className="arbitratorName">{name}</h5>
              <span className="arbitratorRole">Arbitrator</span>
              <div className="arbitratorDivider"></div>
              <p className="arbitratorQualification">{qualification}</p>
              <p className="arbitratorMeta">{designation}</p>
            </div>
          </Col>
        ))}
      </Row>
    </Container>
  );
}

export default OurArbitrators;
